module.exports = __webpack_public_path__ + "img/dacfbf1.png";